module.exports = __webpack_public_path__ + "static/img/dash-8.7ea9249f.png";